var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15026",
    "data-name": "Group 15026",
    transform: "translate(-150 -3670)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    transform: "translate(150 3670)",
    fill: "none",
    stroke: "#313131",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14908",
    "data-name": "Group 14908",
    transform: "translate(158.711 3680.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M30.269,136.745h0l-4.514-4.492a.864.864,0,0,0-1.219,1.225l3.031,3.016h-10.7a.864.864,0,1,0,0,1.728h10.7l-3.031,3.016a.864.864,0,0,0,1.219,1.225l4.514-4.492h0A.865.865,0,0,0,30.269,136.745Z",
    transform: "translate(-16 -132)",
    fill: "#313131"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBorder);
export default __webpack_public_path__ + "static/media/right-arrow-border.8a1d2806d0265c0b2cc703a8b2cab5b8.svg";
export { ForwardRef as ReactComponent };